// src/lib/utils/encodeCardQR.ts
import type { StoreCard } from "../../../lib/types/detailsTypes";

/**
 * Encodes the minimal info the scanner needs to build the Firestore path.
 * Keep it alphanumeric-only so the QR stays compact.
 *
 * QR format:  "<storeId>_<userId>_<cardDocId>"
 */
export function encodeCardQR(card: StoreCard): string {
  const { storeID, userID, cardDocId, uniqueID } = card as any;

  // Fallback if any part is missing (won't break existing cards)
  if (!storeID || !userID || !cardDocId) return uniqueID ?? "UNKNOWN";

  return `${storeID}_${userID}_${cardDocId}`; // ~60-80 chars
}
